import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings,
    deleteSettings,
    clearDeleteSettings
} from '../../../actions/settings';
import { Table } from './Table'
import { news as newsType } from '../../../constants/settingTypes';
import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';
import ConfirmModal from '../../common/ConfirmModal'
import moment from 'moment';

let News = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            confirmModalShow: false,
            newsToEdit: null,
            isMultiple: true
        }

        this._load = this._load.bind(this);
        this._onAddClick = this._onAddClick.bind(this);
        this._onEditClick = this._onEditClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._addNews = this._addNews.bind(this);
        this._updateNews = this._updateNews.bind(this);

        this._onDeleteClick = this._onDeleteClick.bind(this);
        this._onDeleteCanceled = this._onDeleteCanceled.bind(this);
        this._onDeleteConfirmed = this._onDeleteConfirmed.bind(this);

    }

    componentDidMount() {
        this._load();
    }

    _load() {
        this.props.getSettings(newsType);
    }

    _onAddClick() {
        this.setState({ showAddModal: true });
    }

    _addNews(newsModel) {
        this.props.updateSettings(newsType, newsModel,undefined,undefined,this.state.isMultiple);
    }

    _onClose() {
        this.setState({
            showAddModal: false,
            newsToEdit: null,
            showUpdateModal: false
        });
        this.props.clearUpdateSettings(newsType);
    }

    _onEditClick(newsModel) {
        this.setState({ newsToEdit: newsModel, showUpdateModal: true })
    }
    
    _onDeleteClick(newsToDelete) {
        this.setState({ newsToDelete, confirmModalShow: true });
    }
     _onDeleteCanceled() {
        this.setState({ newsToDelete: null, confirmModalShow: false });
        this.props.clearDeleteSettings(newsType);
    }

    _onDeleteConfirmed() {
        this.props.deleteSettings(newsType ,{Id :this.state.newsToDelete.Id});
    }

    _updateNews(newsModel) {
        this.props.updateSettings(newsType, newsModel, newsModel.Id, undefined,this.state.isMultiple);
    }

    render() {
        const { news: { data, fetching,deleteFetching } } = this.props;
        const { showAddModal, showUpdateModal, newsToEdit } = this.state;
        const modalProps = {
            isNew: showAddModal,
            initialValues: newsToEdit ? newsToEdit : { IsActive: true },
            onClose: this._onClose,
            onSubmit: showAddModal ? this._addNews : this._updateNews
        };
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;

        
        return (
            <Panel>
                <Panel.Heading >
                    <span>Новости</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onAddClick} />
                </Panel.Heading>
                <Panel.Body className='box-container'>
                    <Table
                        fetching={fetching}
                        deleteFetching={deleteFetching}
                        news={data}
                        onEdit={this._onEditClick}
                        onDelete ={this._onDeleteClick}
                        isReadOnly={isReadOnly} />
                    {(showAddModal || showUpdateModal) && <EditModal {...modalProps} />}
                    {this.state.confirmModalShow &&
                        <ConfirmModal
                            onYes={this._onDeleteConfirmed}
                            onNo={this._onDeleteCanceled}
                            fetching={deleteFetching}
                            message={`Удалить новость под Id ${moment(this.state.newsToDelete.Id)}?`}
                            title="Вы уверены?"
                            show={true} />}
                </Panel.Body>
            </Panel>
        );
    }
}
News = connect(state => {
    return { news: state.application.get('settings')[newsType] };
}, { getSettings, updateSettings, clearUpdateSettings, deleteSettings ,clearDeleteSettings})(News);

export default News;


// WEBPACK FOOTER //
// ./src/components/settings/news/News.jsx